var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6244 14.8743L23 10.0529V18.375C23 19.8223 21.7886 21 20.3 21H7.70004C6.21139 21 5 19.8223 5 18.375V10.0529L11.3756 14.8743C12.1478 15.4579 13.0738 15.7502 14 15.7502C14.9262 15.7502 15.8523 15.4579 16.6244 14.8743ZM12.4803 13.4925L5.45129 8.17687C5.93556 7.46905 6.7617 7 7.69961 7H20.2995C21.2384 7 22.0645 7.46905 22.5487 8.17687L15.5198 13.4925C14.6251 14.169 13.3749 14.169 12.4803 13.4925Z",
    fill: "#4F6E90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6244 14.8214L23 10V18.3221C23 19.7693 21.7886 20.9471 20.3 20.9471H7.70004C6.21139 20.9471 5 19.7693 5 18.3221V10L11.3756 14.8214C12.1478 15.405 13.0738 15.6972 14 15.6972C14.9262 15.6972 15.8523 15.405 16.6244 14.8214Z",
    fill: "#8DADD0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.95c4a30f8dcf79d344161bccc0c45361.svg";
export { ForwardRef as ReactComponent };